import React, { useState } from 'react';
// import CloseIcon from '@material-ui/icons/Close';
import CloseIcon from '@mui/icons-material/Close'
import com1 from '../../images/gallery/commercial/1.jpg';
import com2 from '../../images/gallery/commercial/2.jpg';
import com5 from '../../images/gallery/commercial/5.jpg';
import resp1 from '../../images/gallery/residencia/1.png';
import resp2 from '../../images/gallery/residencia/2.png';
import res3 from '../../images/gallery/residencia/3.jpg';
import res4 from '../../images/gallery/residencia/4.jpg';
import res7 from '../../images/gallery/residencia/7.jpg';
import '../../styles/portfolio.css';

const Portfolio = () => {
  let data = [
    {
      id: 1,
      imgSrc: com1,
      alt: 'Comercio portfolio 1',
    },
    {
      id: 2,
      imgSrc: com2,
      alt: 'Comercio portfolio 2',
    },
    {
      id: 3,
      imgSrc: com5,
      alt: 'Comercio portfolio 5',
    },
    {
      id: 11,
      imgSrc: res3,
      alt: 'Residential portfolio 3',
    },
    {
      id: 12,
      imgSrc: res4,
      alt: 'Residential portfolio 4',
    },
    {
      id: 15,
      imgSrc: res7,
      alt: 'Residential portfolio 7',
    },
    {
      id: 16,
      imgSrc: resp1,
      alt: 'Residential portfolio 8',
    },
    {
      id: 17,
      imgSrc: resp2,
      alt: 'Residential portfolio 9',
    },
  ];

  const [model, setModel] = useState(false);
  const [tempImgSrc, setTempImgSrc] = useState('');

  const handleImageClick = (imgSrc) => {
    setTempImgSrc(imgSrc);
    setModel(true);
  };

  const closeModal = () => {
    setModel(false);
  };

  return (
    <>
      <div className={model ? 'model open' : 'model'} onClick={closeModal}>
        <img src={tempImgSrc} alt="preview" />
        <CloseIcon className="close-icon" />
      </div>
      <div className="portfolio__top-content">
        <h1>Portfolio</h1>
      </div>
      <section id="portfolio">
        <div className="gallery">
          {data.map((item, index) => (
            <div className="pics" key={index} onClick={() => handleImageClick(item.imgSrc)}>
              <img src={item.imgSrc} alt={item.alt} />
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Portfolio;
